import {https, httpsFile} from './http.js';

export function storeGoodsIssue(data){
    return https().post(`goods_issue`,data);
}

export function updateGoodsIssue(data){
    return https().post(`updateGoodsIssue`,data);
}
export function manualExport(data){
    return https().post(`manualExport`,data);
}

export function postGoodsIssue(data){
    return https().post(`postGoodsIssue`,data);
}
export function cancelGoodsIssue(data){
    return https().post(`cancelGoodsIssue`,data);
}

export function index(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate) {
    return httpsFile().get(`goods_issue?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}`);
}

export function show(id){
    return https().get(`goods_issue/${id}`);
}
//
// export function showReceivingReport(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate) {
//     return httpsFile().get(`showReceivingReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}`);
// }
//
// export function showReceivingReportDetails(id){
//     return https().get(`showReceivingReport/${id}`);
// }
//
// export function receiveGoods(data){
//     return https().post(`receiveGoods`,data);
// }
//
// export function getDelivered(MATNR,EBELN,EBELP){
//     return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
// }
// export function getStatus(EBELN){
//     return https().get(`getStatus?EBELN=${EBELN}`);
// }
//
// export function getRequestedQty(MATNR,EBELN){
//     return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
// }


// export function saveReceivingReport(data){
//     return https().post(`saveReceivingReport`,data);
// }